import { makeCustomerCardsRepository } from 'modules/customer/infra/repositories';

import { ChangeContractCardUseCase } from './implementations/ChangeContractCardUseCase';

let instance: ChangeContractCardUseCase | null = null;

export default function makeChangeContractCardUseCase() {
  if (!instance) {
    const repository = makeCustomerCardsRepository();

    instance = new ChangeContractCardUseCase(repository);
  }

  return instance;
}
